<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import { getKennungTitle, getKennungValue, getKZValue } from "@/DataHelper";
import { Globals } from "@/Globals";
import { checkNode, globalsStt } from "@/local";
import { mountedBase, onSave, BaseSetup, onDelete } from "@/DataLoaderStatic";
import { getSiteData } from "@/NavigationHelper";
// import EditTextField from "@/editor/EditTextField.vue";
import { showSnackbar } from "@/UIHelper";
import {
  createEditorValidator,
  provideEditorValidator,
} from "@/components/EditorValidator";
const validator = createEditorValidator();
provideEditorValidator(validator);

const emit = defineEmits(["back", "save"]);

let disabled = ref<boolean>(false);
let clearable = ref<boolean>(false);
let showDeleteMask: boolean = false;
let kostenart = ref<string>("");
let showEssen = ref<boolean>(false);
let showKredit = ref<boolean>(false);
let showBezahlt = ref<boolean>(false);
let showKst = ref<boolean>(false);
let showKst_Beleg = ref<boolean>(false);
let saveVisible = ref<boolean>(false);
let showVollstaendig = ref<boolean>(true);
let belegAzure = ref<boolean>(false);
let setKey = ref<number>(0);
let editAzureBeleg = ref<boolean>(false);
let bezeichnung: string = "";
let activeTabIndex = ref<number>(0);
let queryKostensaetze = ref<string>("Web_Uebersicht_MA_sonstigeBelege");

const pageParams: DataPageParameter = {
  backOnSave: true,
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_NewManKostensatz",
  aic: AUApi.Current.user.aic,
  emitBack: () => emit("back"),
};
const siteData = getSiteData();
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  // bei autom. Belegerkennung KI - Erfassung eines neuen Belegs!
  // aktuell EDIT & NEU ident!
  if (!siteData.newData && (siteData?.belegeAzure || checkNode("RK_Belegerkennung"))) {
    editAzureBeleg.value = true;
  }
  if (siteData?.editQuery) {
    pageParams.query = siteData.editQuery;
    pageParams.mainAic = pageParams.aic;
  }
  if (siteData && siteData?.aicReise) {
    showVollstaendig.value = false;
    // darf nur bei den sonstigen Belegen die auf den MA erfasst werden angezeigt werden!
    const Stamm = globalsStt(Globals.Stt, 0, "RK_TRAVEL");
    if (!pageParams.jokerStt) {
      pageParams.jokerStt = [];
    }
    pageParams.jokerStt.push({
      sync: siteData.aicReise, // aic Stammsatz
      aic: Stamm.aic, // aic Stammtyp
    });
  }
  if (siteData?.belegeAzure || checkNode("RK_Belegerkennung")) {
    belegAzure.value = true;
    pageParams.queryAIC = siteData.aic;
    pageParams.aic = siteData.aic;
    pageParams.bewegungsdaten = false;
    queryKostensaetze.value = "Web_DetailsSonstBelegeMA_DetailmaskeKI";
  } else if (siteData?.bewegungsdaten) {
    pageParams.bewegungsdaten = true;
    pageParams.aic = siteData.aicBewegung;
  } else {
    if (siteData?.aicReise) {
      pageParams.bewegungsdaten = false;
      pageParams.aic = siteData.aicReise;
      pageParams.queryAIC = siteData.aicReise;
      pageParams.zeitbereich = siteData.zeitbereich;
      queryKostensaetze.value = "Web_Tabelle_BelegeProReise";
    } else {
      pageParams.mainAic = AUApi.Current.user.aic;
      pageParams.mainStt = uiData.header.aic_Stamm;
    }
  }
  await mountedBase(uiData, pageParams, false);
  if (siteData.showDelete) {
    showDeleteMask = siteData.showDelete;
  }
  if (!uiData.showLoading && uiData.data) {
    const row = uiData.data[0];

    let bezahlt = false;
    if (belegAzure.value) {
      bezahlt = getKennungTitle("BELEG_BEREITSFIRMABEZAHLT", uiData.columns);
      bezeichnung = "in Bearbeitung";
    } else {
      bezahlt = getKennungTitle("RK_NOTPAYED", uiData.columns);
    }
    if (bezahlt) {
      showBezahlt.value = true;
    }
    let kredit = false;
    if (belegAzure.value) {
      kredit = getKennungTitle("BELEG_FIRMENKREDITKARTE", uiData.columns);
    } else {
      kredit = getKennungTitle("RK_FIRMENKREDITKARTE", uiData.columns);
    }
    if (kredit) {
      showKredit.value = true;
    }
    const essen = getKennungTitle("RK_ANZ_PERS", uiData.columns);
    if (essen) {
      showEssen.value = true;
    }
    const kostenstelle = getKennungTitle("COST_CENTRE", uiData.columns);
    if (kostenstelle) {
      showKst.value = true;
    } else {
      const kostenstelle1 = getKennungTitle("KOSTENSTELLENZUORDNG", uiData.columns);
      if (kostenstelle1) {
        showKst_Beleg.value = true;
      }
    }
    if (row && row.aic_Stamm) {
      saveVisible.value = getKZValue(row, "save", uiData.columns);
    } else {
      const bezColumn = uiData.columns.find((c: any) => c.kennung === "BEZEICHNUNG");
      const gueltigkeit = uiData.columns.find((c: any) => c.kennung === "INVOICE_DATE");
      if (bezColumn) {
        const text = getKennungValue(row, "BEZEICHNUNG", uiData.columns);
        if (!text) {
          uiData.data[0][bezColumn.name] = "in Bearbeitung";
        }
      }
      if (gueltigkeit) {
        uiData.data[0][
          gueltigkeit.name
        ] = uiData.zeitbereich.von.toISOStringWithTZ().substr(0, 10);
      }
    }
    saveVisible.value = true;

    if (belegAzure.value) {
      saveVisible.value = false;
      showDeleteMask = true;
    }
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});
function checkChanged(val: any) {
  saveVisible.value = true;
  setKey.value += +1;
}
async function onSaveBeleg() {
  const { valid, invalidFields } = await validator.validateAsync();
  if (!valid) {
    showSnackbar({
      text:
        "Validierung fehlgeschlagen - Bitte prüfen! (" + invalidFields.join(", ") + ")",
      duration: 4000,
      color: "error",
    });
    return;
  }
  // achtung wird von den Reisen und vom MA direkt auch aufgerufen!
  let aic = siteData.aicReise ?? AUApi.Current.user.aic;
  if (!siteData.reloadData) {
    siteData.reloadData = true;
  }
  let nodeRequest = uiData.saveNodeRequest ?? "";
  if (belegAzure.value) {
    aic = pageParams.aic ?? 0;
  }
  onSave(uiData, pageParams, 0, "", undefined, aic, true, [], nodeRequest)?.then(() => {
    saveVisible.value = false;
    setKey.value += +1;

    emit("back");
  });
}
async function bewDelete() {
  const siteData = getSiteData();
  if (uiData.data && uiData.data[0].aic_Bew_pool) {
    await onDelete(uiData, pageParams, uiData.data[0].aic_Bew_pool, "");
    if (!siteData.reloadData) {
      siteData.reloadData = true;
    }
    emit("back");
  } else if (uiData.data && uiData.data[0].aic_Stamm) {
    if (belegAzure.value) {
      if (
        confirm("Wollen Sie den Datensatz wirklich - mit allen Kostensätzen löschen?")
      ) {
        await onDelete(uiData, pageParams, uiData.data[0].aic_Stamm, "", undefined, true);
      }
    } else {
      await onDelete(uiData, pageParams, uiData.data[0].aic_Stamm, "");
    }
    if (!siteData.reloadData) {
      siteData.reloadData = true;
    }
    emit("back");
  }
}
</script>
<template>
  <v-card :loading="uiData.showLoading">
    <v-card-text v-if="uiData.initialized && !belegAzure">
      <EditComboBox
        v-model="kostenart"
        :disabled="disabled"
        kennung="RK_ARTEN"
        :queryZeitbereich="pageParams.zeitbereich"
      />
      <EditComboBox
        :disabled="disabled"
        kennung="RK_GEBUEHRENREGION"
        :queryZeitbereich="pageParams.zeitbereich"
      />
      <EditWaehrung kennung="ALL_ROUND_PRICE" />
      <EditComboBox v-if="showKst" :disabled="disabled" kennung="COST_CENTRE" />
      <EditSlider v-if="showEssen" class="pt-5" kennung="RK_ANZ_PERS" />
      <EditSwitchButton v-if="showBezahlt" kennung="RK_NOTPAYED" />
      <EditSwitchButton v-if="showKredit" kennung="RK_FIRMENKREDITKARTE" />

      <EditTextArea :clearable="clearable" kennung="MEMO" :disabled="disabled" />

      <EditFileChoicer kennung="DOKUMENT_DATENBANK" />
      <EditSwitchButton
        v-if="showVollstaendig"
        class="pt-1 pl-0"
        kennung="RK_SONSTIGERBELEG_VOLLSTAENDIG"
      />
    </v-card-text>
    <v-card-text v-if="uiData.initialized && belegAzure">
      <template v-if="editAzureBeleg">
        <v-tabs v-model="activeTabIndex">
          <v-tab value="one">Beleg</v-tab>
          <v-tab value="two">Fehler</v-tab>
          <v-tab value="three">Kostenarten</v-tab>
        </v-tabs>
        <v-tabs-window v-model="activeTabIndex">
          <v-tabs-window-item value="one" bg-color="success">
            <v-row class="pt-5">
              <EditComboBox
                :disabled="true"
                :queryZeitbereich="pageParams.zeitbereich"
                kennung="RK_STAMM_REISE"
              />
              <EditComboBox
                :disabled="true"
                :queryZeitbereich="pageParams.zeitbereich"
                kennung="MA_RELATION"
              />
              <v-col cols="12" sm="6">
                <EditTextField v-model="bezeichnung" kennung="BEZEICHNUNG" />
              </v-col>
              <v-col cols="12" sm="6">
                <EditComboBox
                  kennung="RK_LAND"
                  :queryZeitbereich="pageParams.zeitbereich"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <EditDatePicker kennung="INVOICE_DATE" class="pb-4" />
              </v-col>
              <v-col cols="12" sm="6">
                <EditDatePicker kennung="LV_DURCHFUEHRUNG" class="pb-4" />
              </v-col>

              <v-col cols="12" sm="6">
                <EditWaehrung kennung="BRUTTO_WAEHR" v-if="editAzureBeleg" />
              </v-col>
              <v-col cols="12" sm="6">
                <EditComboBox
                  v-if="showKst_Beleg"
                  :disabled="disabled"
                  kennung="KOSTENSTELLENZUORDNG"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <EditSwitchButton
                  v-if="showBezahlt"
                  @changeValue="checkChanged"
                  kennung="BELEG_BEREITSFIRMABEZAHLT"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <EditSwitchButton
                  @changeValue="checkChanged"
                  v-if="showKredit"
                  kennung="BELEG_FIRMENKREDITKARTE"
                />
              </v-col>
            </v-row>
            <EditSwitchButton
              @changeValue="checkChanged"
              v-if="showKredit"
              kennung="RK_SONSTIGEBELEGE_VOLLSTAENDIG_KI"
            />

            <EditTextArea
              :clearable="clearable"
              kennung="MEMO_MEMO"
              @changeValue="checkChanged"
            />

            <EditFileChoicer kennung="ABLAGE" @changeValue="checkChanged" />
            <!-- <EditSwitchButton
          v-if="showVollstaendig"
          class="pt-1 pl-0"
          kennung="RK_SONSTIGERBELEG_VOLLSTAENDIG"
          @changeValue="checkChanged"
        /> -->
          </v-tabs-window-item>
          <v-tabs-window-item value="two" bg-color="success">
            <BaseVGrid
              v-if="uiData.initialized"
              query="RK_Fehlermeldungen_Anzeige"
              :zeitbereich="uiData.zeitbereich"
              :queryAic="pageParams.queryAIC"
              :showClose="false"
            ></BaseVGrid>
          </v-tabs-window-item>
          <v-tabs-window-item value="three" bg-color="success">
            <BaseVGrid
              v-if="uiData.initialized"
              :query="queryKostensaetze"
              :zeitbereich="uiData.zeitbereich"
              :queryAic="pageParams.aic"
              :showClose="false"
            ></BaseVGrid>
          </v-tabs-window-item>
        </v-tabs-window>
      </template>
      <template v-else>
        <v-row class="pt-5">
          <EditComboBox
            :disabled="true"
            :queryZeitbereich="pageParams.zeitbereich"
            kennung="RK_STAMM_REISE"
          />
          <EditComboBox
            :disabled="true"
            :queryZeitbereich="pageParams.zeitbereich"
            kennung="MA_RELATION"
          />
          <v-col cols="12" sm="6">
            <EditTextField v-model="bezeichnung" kennung="BEZEICHNUNG" />
          </v-col>

          <v-col cols="12" sm="6">
            <EditDatePicker kennung="INVOICE_DATE" class="pb-4" />
          </v-col>
        </v-row>
        <EditSwitchButton
          @changeValue="checkChanged"
          v-if="showBezahlt"
          kennung="BELEG_BEREITSFIRMABEZAHLT"
        />

        <EditSwitchButton
          @changeValue="checkChanged"
          v-if="showKredit"
          kennung="BELEG_FIRMENKREDITKARTE"
        />
        <EditTextArea
          :clearable="clearable"
          kennung="MEMO_MEMO"
          @changeValue="checkChanged"
        />
        <EditCheckBox kennung="RK_AUTOM_BELEGERKENNUNG" />
        <EditFileChoicer kennung="ABLAGE" @changeValue="checkChanged" />
      </template>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <CommonBaseButtons
        :key="setKey"
        v-if="uiData.initialized"
        :deleteVisible="showDeleteMask"
        :createVisible="false"
        :refreshVisible="false"
        :backVisible="false"
        @delete="bewDelete"
        :saveVisible="saveVisible"
        @save="onSaveBeleg"
      ></CommonBaseButtons>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.dvhCol {
  padding-right: 10px;
  padding-left: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
